module.exports = {
  FONT_FAMILY: 'BlinkMacSystemFont, "Segoe UI", Roboto,"Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei",SimSun, "sans-serif"'
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@antv/component/lib/const.js
// module id = 16
// module chunks = 0 1 2